import { Stack, Typography } from '@mui/material';
import { CancelToken } from 'apisauce';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import appapi from '../../../../api/apiClient';
import TradeValue from '../../../../assets/images/tradevalue.png';
import MarketValue from '../../../../assets/images/marketValue.png';
import EUA from '../../../../assets/images/eua.png';
import GainLoss from '../../../../assets/images/gainLoss.png';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import { useTranslation } from 'react-i18next';

export default function EUATradeDetails() {
  const [dashboardData, setDashboardData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const { companyDetails, user } = useSelector((state) => state.auth);
  let source2 = CancelToken.source();

  const { t } = useTranslation();

  const getDashboardData = async (date) => {
    source2.cancel();
    source2 = CancelToken.source();
    const response = await appapi.get(
      `/trader/dashboardPortfolio/${user?.companyId}`,
      {},
      {
        cancelToken: source2.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setDashboardData(data?.response);
        setIsLoading(false)
      }
    }
  };

  useEffect(() => {
    getDashboardData();
    return () => {
      if (source2) {
        source2.cancel();
      }
    };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {isLoading && (
        <Stack
          flex={1}
          alignItems={'center'}
          justifyContent={'center'}
        >
          <ActivityIndicator />
        </Stack>
      )}
      {!isLoading && (
        <Stack
          direction={'row'}
          flexWrap={'wrap'}
          className="!px-[23px] !py-[16px]"
        >
          <Stack className="h-[90px] p-[23px] bg-[#F4F8FF] rounded-[8px] w-[30%] !mr-[30px] !mb-[8px]">
            <Stack direction={'row'}>
              <Stack className="h-[30px] w-[30px] rounded-[8px] bg-[#BAD1FF] !mr-[12px] items-center justify-center">
                <img
                  style={{ width: '18px', height: '18px' }}
                  src={TradeValue}
                />
              </Stack>
              <Typography className="fs-12 ff-Roboto fw-medium">{t('Trade Value (€)')}</Typography>
            </Stack>
            <Typography className="fs-18 ff-Roboto fw-medium !ml-[25%]">
              {dashboardData?.tradeValue != null && parseFloat(dashboardData?.tradeValue)?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || '-'}
            </Typography>
          </Stack>
          <Stack className="h-[90px] px-[15px] py-[23px] bg-[#F4F8FF] rounded-[8px] w-[30%] !mr-[30px] !mb-[8px]">
            <Stack direction={'row'}>
              <Stack className="h-[30px] w-[30px] rounded-[8px] bg-[#BAD1FF] !mr-[12px] items-center justify-center">
                <img
                  style={{ width: '18px', height: '18px' }}
                  src={MarketValue}
                />
              </Stack>
              <Typography className="fs-12 ff-Roboto fw-medium">{t('Current Market Value (€)')}</Typography>
            </Stack>
            <Typography className="fs-18 ff-Roboto fw-medium !ml-[25%]">
              {dashboardData?.marketValue != null && parseFloat(dashboardData?.marketValue)?.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }) || '-'}
            </Typography>
          </Stack>
          <Stack className="h-[90px] p-[23px] bg-[#F4F8FF] rounded-[8px] w-[30%] !mb-[8px]">
            <Stack direction={'row'}>
              <Stack className="h-[30px] w-[30px] rounded-[8px] bg-[#BAD1FF] !mr-[12px] items-center justify-center">
                <img
                  style={{ width: '18px', height: '18px' }}
                  src={GainLoss}
                />
              </Stack>
              <Typography className="fs-12 ff-Roboto fw-medium">{t('Overall Gain/Loss')}</Typography>
            </Stack>
            <Stack
              direction={'row'}
              alignItems={'center'}
            >
              <Typography className="fs-18 ff-Roboto fw-medium !ml-[25%]" style={{color: dashboardData?.isGain === 'decrease' ? '#E89300': dashboardData?.isGain === 'increase' ? '#00A632' : null }}>
                {dashboardData?.isGain === 'decrease' ? '-' : '+'}
                {dashboardData?.overAllGainAndLoss != null &&
                  (parseFloat(dashboardData?.overAllGainAndLoss)?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }) + ' %') || '-'}
              </Typography>
              {dashboardData?.overAllGainAndLoss != null ? 
              <>
              {
                dashboardData?.isGain === 'decrease' ? 
                <ArrowDownwardIcon style={{ width: '16px', height: '16px', color: '#E89300' }} /> : dashboardData?.isGain === 'increase' ?
                <ArrowUpwardIcon style={{ width: '16px', height: '16px', color: '#00A632' }} /> : null}</> : null}
            </Stack>
          </Stack>
          <Stack className="h-[90px] p-[23px] bg-[#F4F8FF] rounded-[8px] w-[30%] !mr-[30px] !mb-[8px]">
            <Stack direction={'row'}>
              <Stack className="h-[30px] w-[30px] rounded-[8px] bg-[#BAD1FF] !mr-[12px] items-center justify-center">
                <img
                  style={{ width: '18px', height: '18px' }}
                  src={EUA}
                />
              </Stack>
              <Typography className="fs-12 ff-Roboto fw-medium">{t('EUA Quantity')}</Typography>
            </Stack>
            <Stack direction={'row'}>
              <Typography className="fs-18 ff-Roboto fw-medium !ml-[25%]">
                {dashboardData?.euaQuantity != null && dashboardData?.euaQuantity?.toLocaleString() ||  '-'}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      )}
    </>
  );
}
